import { ViewType } from 'proto/Offer/Accommodation/ViewType';

const viewTypeToUrlValueMap: Partial<Record<ViewType, string>> = {
    [ViewType.PoolView]: 'pool',
    [ViewType.GardenView]: 'garden',
    [ViewType.LandView]: 'land',
};

const urlValueToViewTypeMap: Partial<Record<string, ViewType>> =
    Object.fromEntries(
        Object.entries(viewTypeToUrlValueMap).map(([key, value]) => [
            value,
            key as ViewType,
        ])
    );

export const convertViewTypeToUrlValue = (viewType: ViewType) =>
    viewTypeToUrlValueMap[viewType];

export const convertUrlValueToViewType = (urlValue: string) =>
    urlValueToViewTypeMap[urlValue];
